// ─────────────────────────────────────────────
//  Card — token-driven layout surface (D-05, D-08)
//  Plain non-interactive <div> container with NO click handler:
//  if a card needs to be interactive, the CALLER wraps a child
//  <button> (or <a>) so the action stays a real, focusable control
//  (a11y — never put a click handler on a div, per the rules).
//  Variants differ only in shadow + padding (default vs elevated).
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { color, space, radius, shadow } = tokens;

export default function Card({ variant = "default", children, style }) {
  const v = VARIANTS[variant] || VARIANTS.default;
  return (
    <div style={{ ...styles.base, boxShadow: v.shadow, padding: v.padding, ...style }}>
      {children}
    </div>
  );
}

const VARIANTS = {
  default: { shadow: shadow.sm, padding: space.lg },
  elevated: { shadow: shadow.md, padding: space.xl },
};

const styles = {
  base: {
    background: color.surface.card,
    border: "1px solid " + color.border.default,
    borderRadius: radius.xl,
  },
};
